module.exports = __webpack_public_path__ + "img/is-close.a8253198.png";